import React, { useEffect } from "react";
import { toast } from "react-toastify";
import Chips from "./Chips";
import Players from "./Players";
import GamesHistory from "./GamesHistory";
import Header from "./Header";
import ActiveGameWrapper from "./ActiveGameWrapper";
import ResultGameModal from "./ResultGameModal";
import { useDispatch, useSelector } from "../app/store";
import {
  postStartGame,
  postRemovePlayer,
  postRemoveAllPlayers,
  postAddPlayer,
  postInitGame,
  clearGame,
  clearError,
} from "../features/keno/kenoSlice";

import { clearChips } from "../features/chips/chipsSlice";

import { getProfile, logout } from "../features/auth/authSlice";

const KenoContent = () => {
  const dispatch = useDispatch();
  const { players, isGameOver, isGameProccess, gameInfo, countdown, errorMessage } =
    useSelector((state) => state.keno);
  const { profile } = useSelector((state) => state.auth);
  const { chipsNumber } = useSelector((state) => state.chips);
  const limits = {
    minBet: 50,
    maxBet: 5000,
  };

  useEffect(() => {
    dispatch(postInitGame());
  }, [dispatch]);

  useEffect(() => {
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(clearError());
    }
  }, [dispatch, errorMessage]);

  const activeContent = isGameProccess ? (
    <ActiveGameWrapper />
  ) : (
    <div className="bets">
      <Players
        addPlayerHandler={_addPlayer}
        players={players}
        balls={chipsNumber}
        limits={limits}
        removePlayerHandler={_removePlayer}
        getProfile={getProfile}
      />
      <GamesHistory />
    </div>
  );

  async function clearAllButtonHandler() {
    await dispatch(postRemoveAllPlayers());
    dispatch(clearChips());
    dispatch(getProfile());
  }

  function _onCloseResultModal() {
    dispatch(clearGame());
    dispatch(clearChips());
    dispatch(postInitGame());
  }

  async function _addPlayer(amount) {
    dispatch(await postAddPlayer(amount));
    dispatch(clearChips());
    dispatch(getProfile());
  }

  async function _removePlayer(id) {
    await dispatch(postRemovePlayer(id));
    dispatch(getProfile());
  }

  function _start() {
    dispatch(postStartGame());
  }

  const formatCountdown = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(
      remainingSeconds
    ).padStart(2, "0")}`;
  };

  return (
    <main className="keno-content">
      <Header
        gameID={gameInfo?.gameID}
        time={formatCountdown(countdown)}
        viewedNumbers={gameInfo?.viewedNumbers}
        profile={profile}
        singOut={logout}
        clearAll={clearAllButtonHandler}
        startGame={_start}
        isGameProccess={isGameProccess}
      />
      <div className="content game-zone">
        <div className="field">
          <Chips />
        </div>
        <div className="info">{activeContent}</div>
        <ResultGameModal
          players={players}
          isOpen={isGameOver}
          onClose={_onCloseResultModal}
        />
      </div>
    </main>
  );
};

export default KenoContent;
